export const SET_OPEN_SNACKBAR = "SET_OPEN_SNACKBAR";
export const SET_USER_AUTH = "SET_USER_AUTH";
export const SET_TOTAL_COVID19 = "SET_TOTAL_COVID19";
export const SET_TOTAL_KUNJUNGAN = "SET_TOTAL_KUNJUNGAN";
export const SET_TOTAL_OBAT_EXPIRED = "SET_TOTAL_OBAT_EXPIRED";
export const SET_SELECTED_KARYAWAN = "SET_SELECTED_KARYAWAN";
export const SET_MEDIS = "SET_MEDIS";
export const SET_PEMERIKSAAN_FISIK = "SET_PEMERIKSAAN_FISIK";
export const SET_PEMERIKSAAN_DARAH = "SET_PEMERIKSAAN_DARAH";
export const SET_DATA_MEDIS = "SET_DATA_MEDIS";
export const SET_KEPALA = "SET_KEPALA";
export const SET_THORAX = "SET_THORAX";
export const SET_ABDOMEN = "SET_ABDOMEN";
export const SET_EKTREMITAS = "SET_EKTREMITAS";
export const SET_DATA_OBAT = "SET_DATA_OBAT";
export const GET_LIST_OBAT = "GET_LIST_OBAT";
export const HANDLE_UPDATE_LIST_OBAT = "HANDLE_UPDATE_LIST_OBAT";
export const GET_HISTORY_REKAM_MEDIS = "GET_HISTORY_REKAM_MEDIS";
export const UPDATE_TABS = "UPDATE_TABS";
export const SET_DATA_KARYAWAN = "GET_DATA_KARYAWAN";
export const SET_LOGIN = "SET_LOGIN";
